<template>
  <div class="xbts-section">
    <h3>Current and Upcoming Shows</h3>
 <ul v-if="xbts" >
    <li v-for="(xbt, index) in xbts" :key="xbt.id" >
      <p v-if="index < 10">
      <a :href="xbt['Website']" target="_blank" rel="nofollow">
        {{xbt.Venue}} ~ <i>{{xbt['Show Title']}}</i> ~ {{xbt.City.split(',')[0]}}
      </a>
        <span class="onview">&nbsp; ~ OPEN NOW thru {{xbt['Closing Date']}}</span>
     </p>
    </li>
  </ul>

  <ul v-if="xbtsUpcoming" >
    <li v-for="(xbtup, index) in xbtsUpcoming" :key="xbtup.id" >
      <p v-if="index < 10">
        <a :href="xbtup['Website']" target="_blank" rel="nofollow">
        {{xbtup.Venue}} ~ <i>{{xbtup['Show Title']}}</i> ~ {{xbtup.City.split(',')[0]}}
      </a>
        <span class="onviewalmost">~ OPENING {{xbtup['Opening Date']}} </span>
     </p>
    </li>
  </ul>

        <a href="/shows">See all shows...</a>
        <br> <br>
  <h3> Interviews</h3>
  <ul v-if="interitems">
    <li v-for="(interview, index) in interitems" :key="interview.id" >
      <p v-if="index < 10">
      <a :href="interview['Link']" target="_blank" rel="nofollow">
                <span v-html="getYear(interview['Date'])"></span>&nbsp;
        {{interview['Publication']}}, <i>{{interview['Title']}}</i> with {{interview['Author']}}
      </a>
     </p>
    </li>
  </ul>
</div>

</template>

<script>
import { mapState, mapActions } from 'vuex' // imports from our Store

export default {
  name: 'RecentXbts',
  computed: {
    ...mapState(['exhibitions', 'bibliography', 'press']),

    xbtsUpcoming () {
      return this.filterProgressXbts('Opening Soon')
    },
    xbts () {
      return this.filterProgressXbts('Open')
    },
    interitems () {
      return this.filterPressStuff('Interview')
    }
  },
  methods: {
    ...mapActions(['getExhibitions', 'getBibliography', 'getPress']),
    getRecords () {
      // Get records if don't exist already
      if (!this.exhibitions) this.getExhibitions()
      if (!this.bibliography) this.getBibliography()
      if (!this.press) this.getPress()
    },
    filterProgressXbts (type) {
      if (!this.exhibitions) return []
      const xbts = this.exhibitions.filter(rec => rec['Progress'] === type)
      return xbts // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    filterPressStuff (type) {
      if (!this.press) return []
      const pressInter = this.press.filter(rec => rec['Type'] === type)
      return pressInter
    },
    getYear: date => { date = new Date(date); return date.getFullYear() }
  },
  created () {
    this.getRecords()
  }

}
</script>

<style scoped>
a{
  font-family: serif;
  font-size: 1.2em;
  line-height: 5%;

}
.xbts-section{
  float:left;
  clear:both;
  width: 100%;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
}

ul{
  padding-left: 2.5em;
  text-indent:-2.5em;
  width: 100%;
  line-height: 10%;
}

.onview{
  font-size: 0.7em;
  color: #00b500;
}

.onviewalmost{
  font-size: 0.7em;
  color: #999;
}

p{
  padding-top: 0px;
  padding-bottom: 0px;
}

</style>
